/* Blok „Doplňkové služby" — Jednoduché vrácení zboží.
 * Checkbox přidá/odebere produkt služby přes Cart AJAX API a překreslí
 * košík stejným mechanismem jako cart.js (sections rendering). */

if (!customElements.get("nb-easy-return")) {
  class NbEasyReturn extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector(".nb-er__checkbox");
      this.infoBtn = this.querySelector(".nb-er__info-btn");
      this.info = this.querySelector(".nb-er__info");

      // stopPropagation: change nesmí probublat do <cart-items> (šablona by ho
      // vzala jako změnu množství položky a poslala /cart/change s quantity "on")
      this.checkbox?.addEventListener("change", (event) => {
        event.stopPropagation();
        this.onToggle();
      });
      this.infoBtn?.addEventListener("click", (event) => {
        event.preventDefault();
        const wasHidden = this.info.hidden;
        this.info.hidden = !wasHidden;
        this.infoBtn.setAttribute("aria-expanded", wasHidden);
      });

      // auto-odebrání (orphan): služba sama v košíku, nebo košík na trhu,
      // kde se neprodává. Zámek brání souběhu — element bývá v DOM dvakrát
      // (drawer + stránka košíku) a druhý /cart/change by skončil 404.
      if (this.dataset.orphan === "true" && !window.__nbErRemoveLock) {
        window.__nbErRemoveLock = true;
        this.removeService();
      }
    }

    onToggle() {
      this.classList.add("is-loading");
      if (this.checkbox.checked) {
        this.addService();
      } else {
        this.removeService();
      }
    }

    fetchOpts(body) {
      const base =
        typeof fetchConfig === "function"
          ? fetchConfig()
          : {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            };
      return { ...base, body: JSON.stringify(body) };
    }

    addService() {
      const url = window.routes?.cart_add_url || "/cart/add";
      const body = {
        items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
        sections: this.sectionNames(),
        sections_url: window.location.pathname,
      };
      fetch(url, this.fetchOpts(body))
        .then((response) => response.json())
        .then((state) => this.renderSections(state))
        .catch((error) => this.revert(error));
    }

    removeService() {
      if (!this.dataset.key) return;
      const url = window.routes?.cart_change_url || "/cart/change";
      const body = {
        id: this.dataset.key,
        quantity: 0,
        sections: this.sectionNames(),
        sections_url: window.location.pathname,
      };
      fetch(url, this.fetchOpts(body))
        .then((response) => response.json())
        .then((state) => this.renderSections(state))
        .catch((error) => this.revert(error));
    }

    /* Cíle překreslení — stejné jako CartDrawerItems/CartItems v cart.js */
    sectionTargets() {
      if (this.dataset.context === "drawer") {
        return [
          {
            id: "CartDrawer",
            section: "cart-drawer",
            selector: ".cart-drawer__inner",
          },
          {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section",
          },
        ];
      }
      return [
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items")?.dataset.id,
          selector: ".js-contents",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
        {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer")?.dataset.id,
          selector: ".js-contents-totals",
        },
        {
          id: "main-cart-shipping",
          section: document.getElementById("main-cart-shipping")?.dataset.id,
          selector: ".js-contents-shipping",
        },
        {
          id: "CartDrawer",
          section: "cart-drawer",
          selector: ".cart-drawer__inner",
        },
      ];
    }

    sectionNames() {
      return [
        ...new Set(
          this.sectionTargets()
            .map((target) => target.section)
            .filter(Boolean)
        ),
      ];
    }

    renderSections(state) {
      if (state.errors || state.status) {
        this.revert(state.errors || state.message);
        return;
      }
      const sections = state.sections || {};
      this.sectionTargets().forEach((target) => {
        if (!target.section || !sections[target.section]) return;
        const root = document.getElementById(target.id);
        const element = root?.querySelector(target.selector) || root;
        if (!element) return;
        const parsed = new DOMParser()
          .parseFromString(sections[target.section], "text/html")
          .querySelector(target.selector);
        if (parsed) element.innerHTML = parsed.innerHTML;
      });

      // is-empty stavy (kopie chování cart.js) — item_count vrací jen /cart/change
      if (typeof state.item_count === "number") {
        const isEmpty = state.item_count === 0;
        document.querySelector(".main-cart")?.classList.toggle("is-empty", isEmpty);
        document.querySelector("cart-drawer")?.classList.toggle("is-empty", isEmpty);
        document
          .querySelector("cart-drawer-items")
          ?.classList.toggle("is-empty", isEmpty);
      }

      // POZOR: žádné publish(cartUpdate) — CartDrawerItems na něj reaguje
      // zděděným onCartUpdate(), který do draweru vloží markup stránky košíku
      // (section main-cart-items) → duplicitní blok a rozbitý CartDrawer-Form.
      // Všechna potřebná překreslení už proběhla výše.
      window.__nbErRemoveLock = false;
    }

    revert(error) {
      console.error("nb-easy-return:", error);
      window.__nbErRemoveLock = false;
      this.classList.remove("is-loading");
      if (this.checkbox) this.checkbox.checked = this.dataset.key !== "";
    }
  }

  customElements.define("nb-easy-return", NbEasyReturn);
}
